import Joi from '@hapi/joi'

export const bplMasterDataSyncSchemaObject = {

    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group Required`,
        "any.required": `Group Required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Estate Required`,
        "any.required": `Estate Required`
    }),
    // masterDataTypeID:Joi.number().invalid(0).required().label("Master Data Type").messages({
    //     "any.invalid": `Master Data Type Required`,
    //     "any.required": `Master Data Type Required`
    // })
}














